import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { EMPTY, of } from 'rxjs';
import * as quotesActions from '../actions/quotes.actions';
import { map, exhaustMap, catchError, mergeMap, tap } from 'rxjs/operators';
import { UsersService } from '../../../users.service';
@Injectable()
export class QuotesEffect {
  constructor(private actions$: Actions, private quoteService: UsersService) {}

  rejectQuote$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quotesActions.rejectQuote),
      exhaustMap((action) =>
        this.quoteService.rejectQuote(action.data).pipe(
          map((response) =>
            quotesActions.rejectQuoteSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(quotesActions.rejectQuoteFailure(error))
          )
        )
      )
    )
  );

  rejectTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quotesActions.rejectTrip),
      exhaustMap((action) =>
        this.quoteService.rejectTrip(action.data, action.leadId).pipe(
          map((response) =>
            quotesActions.rejectTripSuccess({ data: response })
          ),
          catchError((error: any) => of(quotesActions.rejectTripFailure(error)))
        )
      )
    )
  );

  requestCallback$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quotesActions.requestCallback),
      exhaustMap((action) =>
        this.quoteService.requestCallback(action.data).pipe(
          map((response) =>
            quotesActions.requestCallbackSuccess({ data: response })
          ),
          catchError((error: any) =>
            of(quotesActions.requestCallbackFailure(error))
          )
        )
      )
    )
  );

  // acceptQuote$ = createEffect(() =>
  //   this.actions$.pipe(
  //     ofType(quotesActions.acceptQuote),
  //     exhaustMap((action) =>
  //       this.quoteService.acceptQuote(action).pipe(
  //         map((response) =>
  //           quotesActions.acceptQuoteSuccess({ data: response })
  //         ),
  //         catchError((error: any) =>
  //           of(quotesActions.acceptQuoteFailure(error))
  //         )
  //       )
  //     )
  //   )
  // );

  compareQuotes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quotesActions.compareQuotes),
      exhaustMap((action) =>
        this.quoteService.compareQuotes(action.data).pipe(
          map((response) =>
            quotesActions.compareQuotesSuccess({ data: response })
          ),
          catchError((error) =>
            of(quotesActions.compareQuotesFailure({ error }))
          )
        )
      )
    )
  );

  leadCompareQuotes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(quotesActions.leadCompareQuotes),
      exhaustMap((action) =>
        this.quoteService.leadCompareQuotes(action.leadId).pipe(
          map((response) =>
            quotesActions.leadCompareQuotesSuccess({ data: response })
          ),
          catchError((error) =>
            of(quotesActions.leadCompareQuotesFailure({ error }))
          )
        )
      )
    )
  );
}
